import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=a5765604&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=a5765604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5765604",
  null
  
)

export default component.exports